
const state = {
   toggled: false
}

const getters = {
   getToggled(state) {
      return state.toggled;
   }
}

const actions = {
   toggleMenu({ commit }) {
      commit("SET_TOGGLED");
   }
}

const mutations = {
   SET_TOGGLED(state) {
      state.toggled = !state.toggled;
   }
}

export default {
   state,
   getters,
   actions,
   mutations
}